<!-- SpeechButton 语音按钮 -->
<script setup lang="ts">
import { Microphone } from '@element-plus/icons-vue';
</script>

<template>
  <div class="el-send-button">
    <el-button circle>
      <el-icon><Microphone /></el-icon>
    </el-button>
  </div>
</template>

<style scoped lang="scss"></style>
